import { createIcon } from '@chakra-ui/react';

export const MbeBars = createIcon({
  displayName: 'MbeBars',
  viewBox: '0 0 32 32',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.7 25.389H4.3c-.718 0-1.3.585-1.3 1.305C3 27.415 3.582 28 4.3 28h23.4c.718 0 1.3-.585 1.3-1.306 0-.72-.582-1.305-1.3-1.305zM4.3 7.11h23.4c.718 0 1.3-.585 1.3-1.305 0-.721-.582-1.306-1.3-1.306H4.3c-.718 0-1.3.585-1.3 1.306 0 .72.582 1.305 1.3 1.305zm23.4 7.833H4.3c-.718 0-1.3.585-1.3 1.306 0 .72.582 1.306 1.3 1.306h23.4c.718 0 1.3-.585 1.3-1.306 0-.72-.582-1.306-1.3-1.306z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  ),
});
